import { z } from 'zod';

// ── Home Summary (GET /api/v1/dashboard/home-summary) ─────────────────────────

const SpendMixItemSchema = z.object({
  category_name: z.string(),
  amount: z.number(),
});

/** Envelope for `GET /api/v1/dashboard/home-summary`. Amounts are MINOR units (paise). */
export const HomeSummaryResponseSchema = z.object({
  success: z.boolean().optional(),
  message: z.string().optional(),
  data: z.object({
    overall_receive: z.number().default(0),
    this_month_spending: z.number().default(0),
    this_month_settled: z.number().default(0),
    active_groups: z.number().default(0),
    pending_settlements: z.number().default(0),
    spend_mix: z.array(SpendMixItemSchema).default([]),
    currency: z
      .object({ code: z.string(), symbol: z.string() })
      .default({ code: 'INR', symbol: '₹' }),
  }),
});

export type HomeSummaryDto = z.infer<typeof HomeSummaryResponseSchema>;

// ── Legacy Dashboard (GET /api/v1/dashboard) ──────────────────────────────────

/** `pending_expense` summary in the dashboard payload — drives the "Needs your Attention" card. */
const PendingExpenseSummarySchema = z.object({
  unassigned_count: z.number().default(0),
  total_amount: z.number().default(0),
  record_count: z.number().default(0),
  incompleted_count: z.number().default(0),
  position: z.string().nullish(),
});

/** `group` summary — counts + the user's overall balance across groups. */
const GroupSummarySchema = z.object({
  has_archived_group: z.boolean().default(false),
  group_count: z.number().default(0),
  over_all_amount: z.number().default(0),
});

/** Envelope of `GET /api/v1/dashboard`: `{ status, message, data }` for the logged-in user. */
export const DashboardResponseSchema = z.object({
  status: z.boolean().optional(),
  message: z.string().optional(),
  data: z.object({
    pending_expense: PendingExpenseSummarySchema.nullish(),
    group: GroupSummarySchema.nullish(),
    unread_notifications: z.number().default(0),
  }),
});

export type DashboardDto = z.infer<typeof DashboardResponseSchema>;
